import { externalFeesInterface, OrderSaleInterface } from "@/interface/order.inteface";
import { Customer } from "@/modules/customer";
import { OrderDeliveryInterface, OrderOptionsInterface } from "@/interface/business/order.interface";
import { ItemInterface } from "@/interface/business/item.interface";
import { Helper } from "@/services/helper";
import { Item } from "@/modules/location";
import { ExternalFess } from "@/modules/orders/external-fess";
import { OrderDelivery } from "@/modules/orders/index";

export default class OrderSale implements OrderSaleInterface {
  readonly id: string = Helper.createUUID();
  customer?: Customer;
  order_option?: OrderOptionsInterface;
  items: Array<ItemInterface> = [];
  external_fees?: externalFeesInterface;
  delivery?: OrderDeliveryInterface | null;
  constructor(data) {
    if (!data) {
      return;
    }

    this.id = data.id;
    this.order_option = data.order_option;
    this.items = data?.items.map((item) => new Item(item));

    if (data.customer) {
      this.customer = new Customer(data.customer);
    }

    if (data.delivery) {
      this.delivery = new OrderDelivery(data.delivery);
    }

    this.external_fees = new ExternalFess(data.external_fees);
  }
}
